export const MAX_NOTIFICATIONS_COUNT = 99;
